/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.CommunicateDecision = {
  _states: {
    rejected: 'reject',
    approved: 'approv',
    un_reviewed: 'unreviewed'
  },

  _stateHumans: {
    rejected: 'Rejected',
    approved: 'Approved',
    un_reviewed: 'Unreviewed'
  },

  _reviews: {
    rejected: 'reject',
    approved: 'approv',
    did_not_review: 'did_not_review'
  },

  _reviewHumans: {
    rejected: 'Rejected',
    approved: 'Approved',
    did_not_review: 'Did not Review'
  },

  _stateIcons: {
    rejected: 'pt-reject',
    approved: 'pt-approv',
    un_reviewed: 'pt-circle-empty',
    did_not_review: 'pt-circle-empty'
  },

  _reviewValues: {
    approved: 'approved',
    rejected: 'rejected',
    did_not_review: 'un_reviewed'
  },

  _selectState(event){
    const $target = $(event.currentTarget);
    const currentState = $target.data('state');
    const currentId = $target.data('id');
    const states = this.reviewRecommendationsEnabled ? this._reviews : this._states;
    const humanNames = this.reviewRecommendationsEnabled ? this._reviewHumans : this._stateHumans;

    $(`#state-drop-down-${currentId}`).removeClass(_.values(states).join(' ')).addClass(states[currentState]);
    $(`#state-drop-down-icon-${currentId}`).removeClass(_.values(this._stateIcons).join(' ')).addClass(this._stateIcons[currentState]);
    $(`#communicate-decision-state-${currentId}`).html(humanNames[currentState]);
    $(`#state-drop-down-list-${currentId}`).find('.state-selectable').removeClass('selected');
    $target.addClass('selected');
    this._setStateInput({documentVersionId: currentId, state: currentState});
    this._manageItemNotes($target);
    return this._checkStates();
  },

  _manageItemNotes(element) {
    const currentState = element.data('state');
    if (currentState == 'rejected') {
      element.closest('.document-decision-card').find('textarea[id$="note"]').parent('div').removeClass('hide');
    }
    else {
      element.closest('.document-decision-card').find('textarea[id$="note"]').parent('div').addClass('hide');
    }
  },

  _setStateInput({documentVersionId, state}) {
    const newState = this.reviewRecommendationsEnabled ? this._reviewValues[state] : state;
    return $(`#state-input-${documentVersionId}`).val(newState);
  },

  _checkStates() {
    if ((this._approvedVersionsCount() === $('.state-drop-downs').length) && ($('.state-drop-downs').length !== 0)) {
      $('#communicate-decision-state').removeClass('rejected').addClass('approved');
      $('#communicate-decision-state-content').html('Approved');
      $('.approve-field').removeClass('hidden')
      return $('#communicate-decision-state-icon').removeClass('pt-reject').addClass('pt-approv');
    } else {
      $('#communicate-decision-state').removeClass('approved').addClass('rejected');
      $('#communicate-decision-state-content').html('Rejected');
      $('.approve-field').addClass('hidden')
      return $('#communicate-decision-state-icon').removeClass('pt-approv').addClass('pt-reject');
    }
  },

  _approvedVersionsCount() {
    return $('.state-drop-downs.approv').length;
  },

  initializeShow(summaryTableId, reviewRecommendationsEnabled) {
    this.reviewRecommendationsEnabled = reviewRecommendationsEnabled;
    this._checkStates();
    return $(document).on('click', '.state-selectable', _.bind(this._selectState, this));
  }
};
